exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row.prod_in_order[data-v-4b9675f8]{margin-bottom:14rem}.perm-order-notes[data-v-4b9675f8]{margin:4em 0 -4em;font-size:14px;font-style:italic}@media screen and (max-width:800px){.row.prod_in_order[data-v-4b9675f8]{margin-bottom:3rem}}", ""]);

// exports
